module.exports = __webpack_public_path__ + "static/media/9.68d8501c.png";